import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from "react";
import { useAuthContext } from "@authentication/context";
import { Flex, Paper, Header3 } from "@base-ui";
import { TabMenu } from "@interdependence-ui";
import UploadImageContent from "./uploadimage/UploadImageContent";
import ImageLibrary from "./imagelibrary/ImageLibrary";
import { deletePrivateMedia } from "@media";
import { closePopup } from "utils/events";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function SelectImagePopup(props) {
  var selectImage = props.selectImage,
    content = props.content;
  var _useState = useState("upload-image"),
    _useState2 = _slicedToArray(_useState, 2),
    currentEntry = _useState2[0],
    setCurrentEntry = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    activeImage = _useState4[0],
    setActiveImage = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    description = _useState6[0],
    setDescription = _useState6[1];
  var _useAuthContext = useAuthContext(),
    getUserAccess = _useAuthContext.getUserAccess,
    getUser = _useAuthContext.getUser;
  var authTicket = getUser().ticket;
  var userAccess = getUserAccess();
  if (!userAccess) return null;
  var entries = [{
    id: "upload-image",
    label: "Ladda upp bild"
  }, {
    id: "select-from-library",
    label: "Välj bild ifrån biblioteket"
  }];
  var preSelect = function preSelect(newImg) {
    if (content !== null && content !== void 0 && content.src) deletePrivateMedia(content.src, authTicket);
    closePopup();
    selectImage(newImg);
  };
  var uploader = /*#__PURE__*/_jsx(UploadImageContent, {
    selectImage: preSelect,
    activeImage: activeImage,
    setActiveImage: setActiveImage,
    description: description,
    setDescription: setDescription
  }, "uploader");
  var library = /*#__PURE__*/_jsx(ImageLibrary, {
    selectImage: preSelect,
    height: 100
  }, "library");
  var activeView = currentEntry === "upload-image" ? uploader : library;
  var popupContent = !userAccess.media ? /*#__PURE__*/_jsx(Flex.Column, {
    p: "sm",
    height: "calc(100% - 54px)",
    children: library
  }) : /*#__PURE__*/_jsxs(Flex.Column, {
    p: "sm",
    height: "calc(100% - 54px)",
    children: [/*#__PURE__*/_jsx(TabMenu, {
      id: "select-type-of-img",
      tabs: entries,
      justifyContent: "center",
      updateSelected: setCurrentEntry,
      selected: currentEntry
    }), activeView]
  });
  return /*#__PURE__*/_jsx(Paper.Row, {
    width: "460px",
    height: "500px",
    children: /*#__PURE__*/_jsxs(Flex.Column, {
      height: "100%",
      children: [/*#__PURE__*/_jsx(Header3, {
        inverted: true,
        m: "0",
        p: "15px 20px",
        backgroundColor: "P3",
        children: "V\xE4lj bild"
      }), popupContent]
    })
  });
}